module.exports = __webpack_public_path__ + "img/dotclub1.40b54143.png";